import { Button, Popover, PopoverContent, PopoverTrigger } from "@heroui/react";
import { Info } from "lucide-react";

export const LimeTooltip = ({ label }: { label: string | undefined }) => {
  if (!label) {
    return null;
  }

  return (
    <Popover showArrow placement="bottom" className="w-96">
      <PopoverTrigger>
        <Button isIconOnly variant="light" className="ml-1 p-0" size="sm">
          <Info size={18} />
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        <div className="px-1 py-2">{label}</div>
      </PopoverContent>
    </Popover>
  );
};
